<template>
  <div class="sub-agent-commission-panel">
    <div class="time-tab-wrap">
      <div ref="timeTabList" class="time-switch-tab">
        <div
          v-for="(tab, index) in timeTabs"
          :key="tab.key"
          :ref="`timeTab-${index}`"
          class="time-tab"
          :class="{ 'active-tab': timeTabIndex === index }"
          @click="handleTimeTab(index)"
        >
          {{ tab.label }}
        </div>
      </div>
      <div class="time-tab-fade"></div>
    </div>
    <div class="summary-card">
      <div class="summary-main">
        <div class="summary-count">
          <img :src="getMatchImg('beans')" alt="" />
          <span>{{ thousandthDigit(totalCommission) }}</span>
        </div>
        <div class="summary-title">{{ $t('lang.Invite.k098') }}</div>
      </div>
      <div class="summary-divider"></div>
      <div class="summary-tip" :class="{ expanded: commissionTipExpanded }" @click="commissionTipExpanded = !commissionTipExpanded">
        <div class="summary-tip-content">
          <MyPLabel class="summary-tip-line" :str="$t('lang.Invite.k142')" :numsOption="commissionTipNums" :customClass="{ bean: 'tip-bean' }" />
          <MyPLabel
            class="summary-tip-line summary-tip-line-second"
            :str="$t('lang.Invite.k143')"
            :numsOption="commissionRateNums"
            :customClass="{ bean: 'tip-bean' }"
          />
        </div>
        <img class="summary-tip-arrow ar-arrow" src="@/assets/packageAssets/common/arrow16.webp" alt="" />
      </div>
    </div>
    <div class="commission-search">
      <input v-model="searchId" maxlength="30" :placeholder="$t('lang.Invite.k088')" />
      <div class="search-divider"></div>
      <div class="search-btn" @click="handleSearch">{{ $t('lang.Invite.k084') }}</div>
    </div>
    <div class="data-table">
      <div class="table-header">
        <div class="th th-agent">{{ $t('lang.BaseCommon.k103') }}</div>
        <div class="th">
          {{ $t('lang.BaseCommon.k031') }}
          <img :src="getMatchImg('beans')" alt="" />
        </div>
        <div class="th">
          {{ $t('lang.BaseCommon.k032') }}
          <img :src="getMatchImg('beans')" alt="" />
        </div>
      </div>
      <div v-for="item in listData" :key="item.presentId" class="table-row" :class="{ inactive: item.inactive }">
        <div class="td td-agent">
          <div class="agent-name-row">
            <span class="agent-name">{{ item.nickname }}</span>
            <img v-if="item.locationFlag" class="country-icon" :src="item.locationFlag | imgPath" alt="" />
          </div>
          <div class="agent-id-row" @click="handleCopy(item.presentId, $t('lang.BaseCommon.k071'))">
            <span>ID：{{ item.presentId }}</span>
            <img class="copy-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/copy-light.webp" alt="" />
          </div>
        </div>
        <div class="td td-center">{{ thousandthDigit(item.commission) }}</div>
        <div class="td td-center">{{ thousandthDigit(item.income) }}</div>
      </div>
      <div v-if="!listData.length && !loading" class="table-empty"></div>
    </div>
  </div>
</template>
<script>
import { apiFetchSubAgentCommissionList, apiFetchSubAgentCommissionTotal } from '@/api/invite'
import eventBus from '@/utils/eventbus.js'
import { LIST_PAGE_SIZE, buildCommissionParams, mapCommissionItem } from './utils/index'
export default {
  name: 'SubAgentCommissionTab',
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      searchId: '',
      searchPresentId: '',
      timeTabIndex: 0,
      listData: [],
      offset: 0,
      limit: LIST_PAGE_SIZE,
      loading: false,
      finished: false,
      commissionTipExpanded: false,
      totalCommission: 0,
      agentIncomeLimit: 0,
      subAgentCommissionRate: 0,
    }
  },
  computed: {
    commissionTipNums() {
      return [
        { value: this.thousandthDigit(this.totalValidIncome), class: 'tip-num-highlight' },
        { value: this.thousandthDigit(this.agentIncomeLimit) },
      ]
    },
    commissionRateNums() {
      return [{ value: this.subAgentCommissionRate ?? 0 }]
    },
    timeTabs() {
      return [
        { key: 'thisWeek', label: this.$t('lang.BaseCommon.k034') },
        { key: 'lastWeek', label: this.$t('lang.BaseCommon.k042') },
        { key: 'twoWeeksAgo', label: this.$t('lang.Invite.k115') },
        { key: 'threeWeeksAgo', label: this.$t('lang.Invite.k116') },
      ]
    },
    totalValidIncome() {
      return this.listData.reduce((sum, item) => sum + (item.income || 0), 0)
    },
  },
  created() {
    eventBus.$on('InviteScroll', this.scrollEvent)
    this.resetList()
    this.fetchCommissionTotal()
    this.fetchCommissionList()
  },
  beforeDestroy() {
    eventBus.$off('InviteScroll', this.scrollEvent)
  },
  methods: {
    getNativeScroll() {
      let parent = this.$parent
      while (parent) {
        if (parent.nativeScroll) {
          return parent.nativeScroll
        }
        parent = parent.$parent
      }
      return null
    },
    resetList() {
      this.listData = []
      this.offset = 0
      this.loading = false
      this.finished = false
    },
    fetchCommissionTotal() {
      apiFetchSubAgentCommissionTotal({
        weekDiff: buildCommissionParams({ timeTabIndex: this.timeTabIndex }).weekDiff,
      }).then((res) => {
        this.totalCommission = (res && res.totalCommission) ?? 0
        this.agentIncomeLimit = (res && res.agentIncomeLimit) ?? 0
        this.subAgentCommissionRate = (res && res.subAgentCommissionRate) ?? 0
      })
    },
    fetchCommissionList() {
      if (this.loading || this.finished) return
      this.loading = true
      apiFetchSubAgentCommissionList(
        buildCommissionParams({
          timeTabIndex: this.timeTabIndex,
          offset: this.offset,
          limit: this.limit,
          presentId: this.searchPresentId,
        })
      )
        .then((res) => {
          const items = ((res && res.list) || []).map((item) => mapCommissionItem(item))
          this.listData = this.listData.concat(items)
          this.offset = this.listData.length
          this.finished = items.length < this.limit
          if (!this.finished) {
            const nativeScroll = this.getNativeScroll()
            nativeScroll && nativeScroll.finishPullUp()
          }
          this.$nextTick(() => {
            const nativeScroll = this.getNativeScroll()
            nativeScroll && nativeScroll.refresh()
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    reloadCommissionData() {
      this.resetList()
      this.fetchCommissionTotal()
      this.fetchCommissionList()
    },
    handleSearch() {
      this.searchPresentId = (this.searchId || '').trim()
      this.reloadCommissionData()
    },
    handleTimeTab(index) {
      this.commissionTipExpanded = false
      if (this.timeTabIndex === index) return
      this.timeTabIndex = index
      this.reloadCommissionData()
      this.$nextTick(() => {
        const tabList = this.$refs.timeTabList
        const tabRef = this.$refs[`timeTab-${index}`]
        const tabEl = Array.isArray(tabRef) ? tabRef[0] : tabRef
        if (tabList && tabEl) {
          const listRect = tabList.getBoundingClientRect()
          const tabRect = tabEl.getBoundingClientRect()
          const offset = tabRect.left - listRect.left - (listRect.width - tabRect.width) / 2
          tabList.scrollTo({ left: tabList.scrollLeft + offset, behavior: 'smooth' })
        }
      })
    },
    scrollEvent(arg) {
      if (arg.type === 'arriveBottom') {
        this.fetchCommissionList()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.sub-agent-commission-panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 12px;

  .time-tab-wrap {
    position: relative;
    width: 100%;

    .time-switch-tab {
      display: flex;
      align-items: center;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      .time-tab {
        flex-shrink: 0;
        padding: 8px 16px;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-14);
        line-height: var(--lh-title-20);
        color: #b2b2b2;
        white-space: nowrap;
        text-align: center;

        &.active-tab {
          background: #f1e8d9;
          border-radius: 36px;
          color: #925e0d;
        }
      }
    }

    .time-tab-fade {
      position: absolute;
      inset-inline-end: 0;
      top: 0;
      width: 44px;
      height: 100%;
      background: linear-gradient(270deg, #fefefe 0%, rgba(254, 254, 254, 0) 100%);
      pointer-events: none;
    }
  }

  .summary-card {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    padding: 16px 12px;
    background: linear-gradient(180deg, #fff0d9 0%, #fefcf8 100%);
    border-radius: 12px;
    box-sizing: border-box;

    .summary-main {
      margin-bottom: 4px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .summary-count {
        display: flex;
        align-items: center;
        font-family: var(--number-font);
        font-weight: var(--fw-600);
        font-size: var(--fs-20);
        line-height: var(--lh-title-28);
        color: #925e0d;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .summary-title {
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-12);
        line-height: var(--lh-body-18);
        color: #ad8a55;
      }
    }

    .summary-divider {
      width: 100%;
      height: 1px;
      background: rgba(173, 138, 85, 0.2);
    }

    .summary-tip {
      display: flex;
      align-items: flex-start;
      padding: 4px 0;
      cursor: pointer;

      .summary-tip-content {
        flex: 1;
        min-width: 0;
        margin-top: 1px;
        overflow: hidden;
        height: var(--lh-label-14);
      }

      .summary-tip-line {
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-10);
        line-height: var(--lh-label-14);
        color: #b2b2b2;
        word-break: break-word;

        :deep(.custom-p-label) {
          margin: 0;
        }

        :deep(.tip-num-highlight) {
          color: #925e0d;
          font-style: normal;
        }

        :deep(.tip-bean) {
          width: 12px;
          height: 12px;
        }
      }

      .summary-tip-line-second {
        margin-top: 4px;
      }

      .summary-tip-arrow {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        margin-inline-start: 4px;
      }

      &:not(.expanded) .summary-tip-content {
        position: relative;

        &::after {
          content: '...';
          position: absolute;
          inset-inline-end: 0;
          top: 0;
          line-height: var(--lh-label-14);
          font-size: var(--fs-10);
          color: #b2b2b2;
          background: linear-gradient(to left, #fefcf8 55%, transparent);
          padding-inline-start: 4px;
        }

        .summary-tip-line:first-child :deep(.custom-p-label) {
          overflow: hidden;
          white-space: nowrap;
        }
      }

      &.expanded .summary-tip-content {
        height: fit-content;
      }

      &.expanded .summary-tip-arrow {
        transform: rotate(180deg);
      }
    }
  }

  .commission-search {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 12px;
    background: #f6f6f5;
    border-radius: 8px;
    overflow: hidden;

    input {
      flex: 1;
      min-width: 0;
      height: 44px;
      padding: 0 12px;
      border: none;
      background: transparent;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-14);
      line-height: var(--lh-body-20);
      color: #333333;

      &::placeholder {
        color: #cccccc;
      }
    }

    .search-divider {
      width: 1px;
      height: 16px;
      background: #d9d9d9;
      flex-shrink: 0;
    }

    .search-btn {
      padding: 12px;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-14);
      line-height: var(--lh-body-20);
      color: #cccccc;
      white-space: nowrap;
    }
  }

  .data-table {
    border: 2px solid #f9f8f6;
    border-radius: 8px;
    overflow: hidden;
    width: 100%;
    margin-top: 8px;
    background: transparent;

    .table-header {
      display: grid;
      grid-template-columns: 35% 33% 32%;

      .th {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        min-width: 0;
        padding: 8px 4px;
        background: #f9f8f6;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-14);
        line-height: var(--lh-title-20);
        color: #925e0d;
        text-align: center;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: break-word;

        &:nth-child(2) {
          border-inline-start: 1.5px solid #edeae3;

          img {
            width: 12px;
            height: 12px;
            margin-inline-start: 2px;
          }
        }

        &:nth-child(3) {
          border-inline-start: 1.5px solid #edeae3;

          img {
            width: 12px;
            height: 12px;
            margin-inline-start: 2px;
          }
        }
      }
    }

    .table-row {
      display: grid;
      grid-template-columns: 35% 33% 32%;

      &.inactive {
        opacity: 0.3;
      }
    }

    .td {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px 4px;
      border-bottom: 1.5px solid #f9f8f6;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-12);
      line-height: var(--lh-label-16);
      color: #333333;
      align-self: stretch;

      &.td-agent {
        flex-direction: column;
        align-items: start;
        padding: 8px 4px;

        .agent-id-row {
          margin-top: 8px;
          display: inline-flex;
          align-items: center;
          max-width: 100%;
          color: #b2b2b2;

          span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .copy-icon {
            margin-inline-start: 2px;
            width: 16px;
            height: 16px;
            flex-shrink: 0;
          }
        }

        .agent-name-row {
          display: inline-flex;
          align-items: center;
          max-width: 100%;
          min-width: 0;

          .country-icon {
            margin-inline-start: 2px;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            flex-shrink: 0;
          }

          .agent-name {
            flex: 0 1 auto;
            max-width: 80px;
            font-size: var(--fs-14);
            line-height: var(--lh-title-20);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      &.td-center {
        min-width: 0;
        flex-wrap: wrap;
        align-content: center;
        text-align: center;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: break-word;
      }
    }

    .table-row:last-child .td {
      border-bottom: none;
    }

    .table-empty {
      min-height: 120px;
      background: #fefefe;
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .sub-agent-commission-panel {
    .time-tab-wrap {
      .time-tab-fade {
        background: linear-gradient(90deg, #fefefe 0%, rgba(254, 254, 254, 0) 100%);
      }
    }

    .summary-card {
      .summary-tip {
        &:not(.expanded) .summary-tip-content::after {
          background: linear-gradient(to right, #fefcf8 55%, transparent);
        }

        &.expanded .summary-tip-arrow {
          transform: rotateY(180deg) rotate(180deg) !important;
        }
      }
    }
  }
}
</style>
